module.exports = __webpack_public_path__ + "static/media/moisture_surge_image.c06b5ff7.png";